"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DeviceManufacturer = void 0;
const DeviceType = Object.freeze({
  BRIGHTSIGN: 'brightsign',
  XUMO: 'xumo',
  CHROMEOS_PWA: 'chromeos pwa'
});
const DeviceManufacturer = exports.DeviceManufacturer = Object.freeze({
  [DeviceType.BRIGHTSIGN]: 'BrightSign',
  [DeviceType.XUMO]: 'Xumo',
  [DeviceType.CHROMEOS_PWA]: 'Google'
});
var _default = exports.default = DeviceType;